export default __webpack_public_path__ + "static/media/reportCover.98c4db82.png";